import { useEffect } from 'react';

const SEO = ({ title, description, keywords, canonicalUrl }) => {
  useEffect(() => {
    // Update document title
    document.title = title ? `${title} | Sporto Krantas` : 'Sporto Krantas - Pramogų ir poilsio centras';

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || 'Sporto Krantas - Pramogų ir poilsio centras gamtos apsuptyje. Darbostogos, šventės, stovyklos, pirties namukas.');
    }

    // Update or create meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', keywords || 'sporto krantas, poilsis, pramogos, darbostogos, šventės, stovyklos, pirtis, gamta, Lietuva');

    // Update or create canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalUrl) {
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.rel = 'canonical';
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('href', canonicalUrl);
    }

    // Open Graph tags
    const ogTags = {
      'og:title': title || 'Sporto Krantas',
      'og:description': description || 'Pramogų ir poilsio centras gamtos apsuptyje',
      'og:type': 'website',
      'og:url': canonicalUrl || 'https://sportokrantas.lt',
      'og:image': 'https://sportokrantas.lt/img/13.jpg',
      'og:site_name': 'Sporto Krantas',
      'og:locale': 'lt_LT'
    };

    Object.entries(ogTags).forEach(([property, content]) => {
      let ogTag = document.querySelector(`meta[property="${property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', content);
    });

  }, [title, description, keywords, canonicalUrl]);

  return null;
};

export default SEO;



